define('v3/Common/Bindings/EnterKey.Binding',[
	'knockout',
	'jquery'
], function (ko, $) {
	ko.bindingHandlers.enterKey = {
		init: function (element, valueAccessor) {
			var callback = valueAccessor();

			var keypressHandler = function (d, event) {
				var keyCode = (event.which ? event.which : event.keyCode);
				if (keyCode === 13) {
					$(element).change();
					callback();
					return false;
				}
				return true;
			};

			ko.applyBindingsToNode(element, { event: { keypress: keypressHandler } });
		}
	};
});
